import { providersService } from '../services';

export const Operacao = async () => {
  const { data } = await providersService.getOperacao();
  return data;
};
